import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CONFIG } from "../../data";

export const FloatingWhatsApp = () => {
  const [hover, setHover] = useState(false);
  const link = `https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent(CONFIG.waMessage)}`;

  return (
    <motion.a
      data-testid="floating-whatsapp"
      href={link} target="_blank" rel="noopener noreferrer"
      onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}
      initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.8, type: "spring", stiffness: 200 }}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3"
      aria-label="Chat on WhatsApp"
    >
      <AnimatePresence>
        {hover && (
          <motion.span
            initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 10 }}
            className="hidden sm:block glass-dark text-ivory font-body text-sm px-4 py-2 rounded-full whitespace-nowrap">
            Citizen Queries & Assistance
          </motion.span>
        )}
      </AnimatePresence>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full shadow-[0_10px_30px_rgba(19,136,8,0.4)]"
        style={{ background: "#25D366" }}>
        <span className="absolute inline-flex h-full w-full rounded-full opacity-40 animate-ping" style={{ background: "#25D366" }} />
        <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
          <path d="M17.6 6.32A7.85 7.85 0 0 0 12.05 4a7.94 7.94 0 0 0-6.9 11.9L4 20l4.2-1.1a7.9 7.9 0 0 0 3.8.97h.01a7.94 7.94 0 0 0 5.59-13.55ZM12.05 18.5a6.6 6.6 0 0 1-3.36-.92l-.24-.14-2.5.65.67-2.43-.16-.25a6.59 6.59 0 1 1 5.59 3.09Zm3.62-4.94c-.2-.1-1.17-.58-1.35-.64s-.31-.1-.44.1-.5.64-.62.77-.23.15-.43.05a5.4 5.4 0 0 1-1.59-.98 6 6 0 0 1-1.1-1.37c-.11-.2 0-.3.09-.4l.3-.35a1.36 1.36 0 0 0 .2-.33.37.37 0 0 0-.02-.35c-.05-.1-.44-1.07-.6-1.46s-.32-.34-.44-.34h-.38a.72.72 0 0 0-.52.24 2.2 2.2 0 0 0-.69 1.64 3.83 3.83 0 0 0 .8 2.03 8.75 8.75 0 0 0 3.35 2.96c.47.2.83.32 1.11.42a2.68 2.68 0 0 0 1.23.08c.37-.06 1.17-.48 1.34-.94s.17-.86.12-.94-.18-.14-.38-.24Z" />
        </svg>
      </span>
    </motion.a>
  );
};
